import { createContext } from 'react';
import CopilotChannel from './CopilotChannel';
import { ChannelState } from '../types/Channel';
import {
  CopilotTelemetry,
  noopCopilotTelemetry,
} from '../types/CopilotTelemetry';

type CopilotChannelContextType = {
  channel: CopilotChannel | undefined;
  channelState: ChannelState;
  instanceId?: string;
  // Optional so consumers that build this value by hand (tests, storybook
  // decorators) don't need to supply it; read sites default to the no-op.
  telemetry?: CopilotTelemetry;
};

export const CopilotChannelContext = createContext<CopilotChannelContextType>({
  channel: undefined,
  channelState: {
    appContext: {},
    isCanvasOpen: false,
    isCopilotExpanded: false,
    isNavCopilotAvailable: false,
    isWidgetOpen: false,
    isWidgetActive: false,
    layoutType: 'panel',
    breezeContext: {
      messageContexts: [],
      context: {},
      turnMetadata: {},
      conversationMetadata: {},
      agentId: undefined,
    },
  },
  instanceId: undefined,
  telemetry: noopCopilotTelemetry,
});
